<template>
  <v-footer>
    <div>
      <div class="copyrightText">{{ props.copyright }}</div>
      <nav class="footerLinks" aria-label="Footer">
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel1"
            :href="props.href[0]"
            new-tab
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          <span class="separator" aria-hidden="true">|</span>
        </span>
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel2"
            :href="props.href[1]"
            new-tab
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          <span class="separator" aria-hidden="true">|</span>
        </span>
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel3"
            :href="props.href[2]"
            new-tab
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          <span class="separator" aria-hidden="true">|</span>
        </span>
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel4"
            :href="props.href[3]"
            new-tab
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
          <span class="separator" aria-hidden="true">|</span>
        </span>
        <span class="footerRow">
          <EgovLink
            class="footerLink"
            :label="props.linkLabel5"
            :href="props.href[4]"
            new-tab
            variant="inline"
            size="small"
            append-icon=""
          ></EgovLink>
        </span>
      </nav>
    </div>
  </v-footer>
</template>

<script setup>
import EgovLink from './EgovLink.vue'

const props = defineProps({
  copyright: { type: String, required: true },
  linkLabel1: { type: String, required: true },
  linkLabel2: { type: String, required: true },
  linkLabel3: { type: String, required: true },
  linkLabel4: { type: String, required: true },
  linkLabel5: { type: String, required: true },
  href: { type: Array, required: true },
})
</script>

<style lang="scss" scoped>
.v-footer {
  max-height: fit-content;
  width: 100%;
  background-color: var(--kds-surface-container-highest);
  overflow: auto;
  scrollbar-width: normal;

  @media (max-width: 1000px) {
    justify-content: center;
  }
}
.v-footer > div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: fit-content;
  margin: 0 auto;
  max-width: 1440px;
  width: 100%;
  justify-content: space-between;
  overflow: auto;
  scrollbar-width: normal;

  @media (max-width: 1000px) {
    flex-direction: column;
    justify-content: center;
  }
}

.copyrightText {
  display: inline-flex;
  font-size: 12.5px;
  align-items: center;
  color: var(--kds-on-surface);
  white-space: nowrap;

  @media (max-width: 1000px) {
    width: 100%;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center;
    white-space: normal;
  }
}

.footerLinks {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  font-size: small;
  color: var(--kds-on-surface);
  justify-content: flex-end;
  max-width: 1070px;
  margin-left: 24px;

  @media (max-width: 1000px) {
    flex: 0 1 auto;
    width: 100%;
    justify-content: center;
    margin-left: 0;
  }
}

.footerRow {
  display: flex;
  align-items: center;
  margin: 5px 0;
  white-space: nowrap;
}

.footerLink {
  margin: 0px 5px;
  overflow: visible;

  :focus {
    color: var(--kds-on-surface);
  }
}

.separator {
  @media (max-width: 1000px) {
    display: none;
  }
}
</style>